import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, useFormContext } from 'react-hook-form';
import { RegistrationsFormSchema, UseFormTypes } from '~/types';
import { useConfigSettings } from './useConfigSettings';
import { useThemeSettings } from './useThemeSettings';

export function useRegistrationSettingsForm() {
  const { data: themeSettings } = useThemeSettings();

  const { data: registrationSettings } = useConfigSettings(
    ({ registrations }) => registrations,
  );

  return useForm({
    resolver: zodResolver(RegistrationsFormSchema),
    defaultValues: {
      customFields: registrationSettings?.customFields ?? [],
      isRegistrationEnabled: false,
      theme: {
        emailMarketingConsentText:
          themeSettings?.emailMarketingConsentText ??
          'Opt-in for marketing emails ',
        emailMarketingConsentDescriptionText:
          themeSettings?.emailMarketingConsentDescriptionText ??
          'By submitting this registration, you agree to receive marketing emails.',
        emailMarketingConsentPolicyUrlTextTitle:
          themeSettings?.emailMarketingConsentPolicyUrlTextTitle ??
          'View our privacy policy',
      },
    },
    values:
      registrationSettings && themeSettings
        ? {
            ...registrationSettings,
            theme: {
              emailMarketingConsentText:
                themeSettings.emailMarketingConsentText ?? '',
              emailMarketingConsentDescriptionText:
                themeSettings.emailMarketingConsentDescriptionText ?? '',
              emailMarketingConsentPolicyUrlTextTitle:
                themeSettings.emailMarketingConsentPolicyUrlTextTitle ?? '',
              identifyProductUrl: themeSettings.identifyProductUrl ?? '',
              identifyProductUrlButtonText:
                themeSettings.identifyProductUrlButtonText ?? '',
              identifyProductDetailText:
                themeSettings.identifyProductDetailText ?? '',
              identifyProductFormPlaceholder:
                themeSettings.identifyProductFormPlaceholder ?? '',
              orderLookupRegistrationText:
                themeSettings.orderLookupRegistrationText ?? '',
              isRegistrationPhoneRequired:
                themeSettings.isRegistrationPhoneRequired ?? false,
              registrationSubmissionText:
                themeSettings.registrationSubmissionText ?? '',
              registrationCountryCodes:
                themeSettings.registrationCountryCodes ?? [],
            },
          }
        : undefined,
  });
}

export function useRegistrationSettingsFormContext() {
  type FormType = UseFormTypes<typeof useRegistrationSettingsForm>;
  return useFormContext<
    FormType['FieldValues'],
    FormType['Context'],
    FormType['TransformedValues']
  >();
}
